import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { classToPlain, plainToClass } from 'class-transformer';
// Constant imports
import { URLConstants } from '../../_constants/url-constants';
// Model imports
import { TimeExpenseSubmissionHistoryResultDto } from '../_models/time-expense-submission-history-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class TimeExpenseComfirmationService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this._subjectLoading = new Subject();
    }
    onLoadingEvent() {
        return this._subjectLoading;
    }
    showLoading() {
        this._subjectLoading.next(true);
    }
    hideLoading() {
        this._subjectLoading.next(false);
    }
    getTimeAndExpenseSubmissionDetail(baseParams) {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/detail${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((plain) => plainToClass(TimeExpenseSubmissionHistoryResultDto, plain)));
    }
    getTimeAndExpenseReport(baseParams) {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/report${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url, { responseType: 'arraybuffer' })
            .pipe(map((response) => new Blob([response])));
    }
    updateTimeNotes(params) {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/item/time/note`;
        return this.httpClient.put(url, classToPlain(params));
    }
    updateExpenseNotes(params) {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/item/expense/note`;
        return this.httpClient.put(url, classToPlain(params));
    }
    updateMileageNotes(params) {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/item/mileage/note`;
        return this.httpClient.put(url, classToPlain(params));
    }
    approveTimeExpenseSubmission(params) {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/approve`;
        return this.httpClient.put(url, classToPlain(params));
    }
    denyTimeExpenseSubmission(params) {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/deny`;
        return this.httpClient.put(url, classToPlain(params));
    }
}
TimeExpenseComfirmationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TimeExpenseComfirmationService_Factory() { return new TimeExpenseComfirmationService(i0.ɵɵinject(i1.HttpClient)); }, token: TimeExpenseComfirmationService, providedIn: "root" });
